"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const tripsService = {
  createTrip: function (options) {
    return api.post(`/Trips`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteTrip: function (options) {
    return api.delete(`/Trips`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  updateTripControlPoints: function (options) {
    return api.put(`/TripControlPoints`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  createTripUnit: function (options) {
    return api.post(`/TripUnits`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteTripUnit: function (options) {
    return api.delete(
      `/TripUnits`,
      WithToken.headersToken({ params: { tripId: options.tripId, unitId: options.unitId } }, configuration.cookieName)
    );
  },
};

export default tripsService;
